package com.eladfinish.bible.contest.ui.components.loaders

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.size
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.dp
import com.eladfinish.bible.contest.ui.extensions.interceptTouchEvents

@Composable
fun ScreenLoaderHost(isLoading: Boolean) {
    // Always composed; only visibility changes
    Box(
        modifier = Modifier
            .fillMaxSize()
            .graphicsLayer { alpha = if (isLoading) 1f else 0f }
            .then(if (isLoading) Modifier.interceptTouchEvents() else Modifier)
            .background(Color.Black.copy(alpha = 0.6f))
    ) {
        if (isLoading) {
            CircularLoader(
                strokeWidth = 8.dp,
                modifier = Modifier
                    .size(60.dp)
                    .align(Alignment.Center)
            )
        }
    }
}
